import customerService from "apis/customerService";
import {
  REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS
} from "typeConstants";
import { WebApiReduxRequest, HTTP_GET } from "tools/webservice";

export const getCustomerServiceAssignToUsers = () => WebApiReduxRequest(
  REQUEST_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  RECEIVE_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  ERROR_CUSTOMER_SERVICE_ASSIGN_TO_USERS,
  HTTP_GET,
  customerService.getCustomerServiceAssignToUsers()
);
